import { TextBody } from '@isdd/idsk-ui-kit/typography/TextBody'
import React, { useRef } from 'react'
import { Uppy } from '@uppy/core'
import { useTranslation } from 'react-i18next'

import styles from './FileImport.module.scss'
import './FileImport.scss'
import { useDropzone } from '@uppy/react'
import { Button } from '@isdd/idsk-ui-kit/index'

interface IFileImportDragDrop {
    uppy: Uppy
    hideNoSelectedFileToImport?: boolean
}

export const FileImportDragDrop: React.FC<IFileImportDragDrop> = ({ uppy, hideNoSelectedFileToImport }) => {
    const { t } = useTranslation()

    const inputRef = useRef<HTMLInputElement | null>(null)
    const { getRootProps, getInputProps } = useDropzone({ noClick: true })

    return (
        <div className={styles.dragDropWrapper} data-uppy-element="dropzone" role="presentation" {...getRootProps()}>
            <TextBody>
                <strong>{t('fileImport.dropHere')}</strong>
            </TextBody>
            <TextBody size="S">
                <i>{t('fileImport.or')}</i>
            </TextBody>
            <div>
                <div className={styles.fileInputButtonDiv}>
                    <Button label={t('fileImport.chooseFile')} onClick={() => inputRef.current?.click()} />
                    <input
                        ref={inputRef}
                        {...getInputProps()}
                        type="file" // ensure it's file
                        style={{ display: 'none' }} // OK here because label triggers it
                    />
                </div>
                {!hideNoSelectedFileToImport && <TextBody size="S">{t('fileImport.browse')}</TextBody>}
            </div>
        </div>
    )
}
